import { ActivityEntityName, JobTemplateCode } from '@jms/model';
import { itemFamilyBoard } from '@workbuddy/entities/work.job.item/job.item.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { ITEM_BROWSER_DIALOG_PRESENTATION } from '@workbuddy/ui/blocks/line.items';

/**
 * RecurringJobTemplateItem entity manifest.
 *
 * Roots the same `recurringjobs` documents as Recurring Job but at its own metadata chain
 * (RecurringJobTemplateItem → jobTemplate.template.workOrders → codes), so the items board inherits
 * none of Recurring Job's column, filter or grouping affordances. One row = one item of the template
 * every generated job is stamped from.
 *
 * **Create** is `kind: 'custom'` (the shared catalogue ItemBrowser dialog), not a Surface Engine
 * form. There is no `edit` operation: a template item has no execution state to inspect, so the
 * inline row editor is the whole edit surface. Board and editor use the embedded-item base below.
 */
export const recurringJobTemplateItemManifest = registerManifest<JobTemplateCode>({
  entity: ActivityEntityName.RecurringJobTemplateItem,
  slug: 'recurring-job-template-item',

  operations: {

    // Custom dialog: multi-select catalogue → AddItems.
    create: {
      kind: 'custom',

      // Shared shell; this entity's wording and write arrive as params.itemBrowser.
      load: () => import('@workbuddy/entities/shared/item.browser.dialog').then(m => m.ItemBrowserDialogComponent),
      presentation: {
        mode: 'dialog',
        ...ITEM_BROWSER_DIALOG_PRESENTATION,
      },
    },
  },

  board: itemFamilyBoard,
});
